import _isEmpty from 'lodash/isEmpty';
import { useEffect } from 'react';
import { useMqttClient } from './useMqttClient';

export function useMqttSubscription(
  topic: string | string[] | undefined,
  { onMessage }: { onMessage: (message: string | Buffer) => void },
) {
  const { client, connectClient, subscribeToTopic, unsubscribeFromTopic } = useMqttClient();

  useEffect(() => {
    if (!client && !_isEmpty(topic)) {
      // subscribe only after shared provider creates client, then remove only this listener on cleanup
      void connectClient();
      return;
    }

    if (client && !_isEmpty(topic)) {
      // subscribe only after shared provider creates client, then remove only this listener on cleanup
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- checked with isEmpty above
      const _topic = topic!;
      subscribeToTopic(_topic, onMessage);

      return () => {
        unsubscribeFromTopic(_topic, onMessage);
      };
    }
  }, [client, connectClient, onMessage, subscribeToTopic, topic, unsubscribeFromTopic]);
}
